import { Dimensions, Image, StyleSheet, Text, View } from "react-native";
import React from "react";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { formatCPF, formatRG } from "../../../../utils/CPFFunctions";
import QRCode from "react-native-qrcode-svg";
import useFetchImage from "../../../../hooks/useFetchImage";
import OverlayGIF from "./OverlayGIF";

const studentFront = require("../../../../../assets/images/cards/newisicfrente.png");
const defaultProfilePic = require("../../../../../assets/images/home/default-avatar-profile-image.jpg");
const DNECard = () => {
  const user = useAppSelector((s) => s.auth.subUser!);
  let qrCodeString = "https://e1.cl/" + user.card.fesn_data.fesn_national_id;
  const isDefault =
    user.card?.images && user.card.images.front !== "Base-front-image"
      ? false
      : true;
  let userCardImageSource: any = !isDefault
    ? { uri: user.card!.images.front }
    : defaultProfilePic;
  const dateNow = new Date();
  const status =
    user &&
    user.card?.fesn_data?.status &&
    user.card?.fesn_data?.status !== "Pending"
      ? new Date(user.card?.expiry) > dateNow
        ? "VALID"
        : "EXPIRED"
      : "PENDING";
  const imageSrc = useFetchImage(
    "/users/profile/image/",
    user.card.images.front
  );
  if (imageSrc) {
    userCardImageSource = { uri: imageSrc };
  }
  const CardSrc = useFetchImage(
    "/users/profile/card/images/",
    user.card.display_images.front
  );
  return (
    <View style={styles.cardContainer}>
      <Image
        source={{ uri: CardSrc }}
        style={[styles.card, status !== "VALID" && { tintColor: "gray" }]}
        resizeMode="contain"
      />
      {status !== "VALID" && (
        <Image
          source={{ uri: CardSrc }}
          style={[styles.card, { opacity: 0.3, position: "absolute" }]}
          resizeMode="contain"
        />
      )}
      <View style={styles.cardContent}>
        <Text style={[styles.name, styles.bold]}>{user.name}</Text>
        <Text style={styles.school}>{user.card?.institution}</Text>
        <Text style={styles.course}>{user.card?.course}</Text>
        <Text style={styles.cpf}>{user.cpf && formatCPF(user.cpf)}</Text>
        <Text style={styles.rg}>{user.card?.rg && formatRG(user.card.rg)}</Text>
        <Text style={styles.dob}>{user.card?.dob}</Text>
        <Text style={styles.institution_id}>{user.card?.institution_id}</Text>
        <Text style={styles.national_id}>
          {user.card?.fesn_data.fesn_national_id}
        </Text>
        <Image
          source={userCardImageSource}
          style={[
            styles.cardImage,
            status !== "VALID" && { tintColor: "gray" },
          ]}
		  resizeMode="stretch"
        />
        {status !== "VALID" && (
          <Image
            source={userCardImageSource}
            style={[styles.cardImage, { opacity: 0.3, position: "absolute" }]}
            resizeMode="stretch"
          />
        )}
        <View style={styles.qr}>
          <QRCode value={qrCodeString} size={cardWidth * 0.2} />
        </View>
      </View>
      {user?.card &&
        user.card?.fesn_data?.status !== "Pending" &&
        new Date(user.card?.expiry) > dateNow && <OverlayGIF />}
    </View>
  );
};

export default DNECard;
const windowWidth = Dimensions.get("window").width;
const ratio = 1460  / 920;
const cardWidth = windowWidth * 0.95 ;
const cardHeight = cardWidth * ratio ;
const styles = StyleSheet.create({
  cardContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    marginTop: 50,
  },
  card: {
    borderRadius: 20,
    height: cardHeight,
    width: cardWidth,
  },
  cardContent: {
    position: "absolute",
    width: cardHeight,
    height: cardWidth,
    transform: [{ rotate: "270deg" }],
  },
  name: {
    position: "absolute",
    fontSize: 14,
    lineHeight: 14,
    top: cardWidth * 0.310,
    left: cardHeight * 0.350,
  },
  school: {
    position: "absolute",
    fontSize: 14,
    lineHeight: 14,
    top: cardWidth * 0.360,
    left: cardHeight * 0.350,
  },
  course: {
    position: "absolute",
    fontSize: 14,
    lineHeight: 14,
    top: cardWidth * 0.410,
    left: cardHeight * 0.350,
  },
  cpf: {
    position: "absolute",
    fontSize: 14,
    lineHeight: 14,
    width: 200,
    top: cardWidth * 0.475,
    left: cardHeight * 0.415,
  },
  rg: {
    position: "absolute",
    top: cardWidth * 0.545,
    left: cardHeight * 0.415,
    fontSize: 14,
    lineHeight: 14,
    width: 200,
  },
  dob: {
    position: "absolute",
    top: cardWidth * 0.615,
    left: cardHeight * 0.510,
    fontSize: 14,
    lineHeight: 14,
    width: 200,
  },
  institution_id: {
    position: "absolute",
    top: cardWidth * 0.685,
    left: cardHeight * 0.505,
    fontSize: 14,
    lineHeight: 14,
    width: 200,
  },
  national_id: {
    position: "absolute",
    top: cardWidth * 0.828,
    left: cardHeight * 0.560,
    fontSize: 14,
    lineHeight: 14,
    width: 200,
  },
  cardImage: {
    position: "absolute",
    width: cardWidth * 0.45,
    height: cardHeight * 0.338,
    left: cardHeight * 0.032,
    top: cardWidth * 0.164,
  },
  qr: {
    position: "absolute",
    left: cardHeight * 0.108,
    top: cardWidth * 0.738,
  },
  text: {
    fontSize: 16,
  },
  bold: { fontWeight: "bold" },
});
